import React from 'react';
import PropTypes from 'prop-types';

import { StyledTypography } from './styled';

const Typography = ({
  children,
  variant = 'primary',
  mb,
  mt,
  color = 'grey',
  textAlign = 'left',
  ellipsis = false,
  style,
}) => {
  const as = variant === 'title' ? 'h2' : 'p';

  return (
    <StyledTypography
      as={as}
      variant={variant}
      mb={mb}
      mt={mt}
      color={color}
      textAlign={textAlign}
      style={style}
      ellipsis={ellipsis}
    >
      {children}
    </StyledTypography>
  );
};

Typography.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  variant: PropTypes.oneOf(['title', 'primary']),
  mt: PropTypes.number,
  mb: PropTypes.number,
  color: PropTypes.string,
  textAlign: PropTypes.string,
  ellipsis: PropTypes.bool,
};

export default Typography;
